import { useGetCurrentProject } from '../use-get-current-project';
import { isProjectEditable } from '../use-is-project-editable';

/**
 * ### useGetIsProjectLocked
 * @description
 * Hook that checks if the current project is locked
 * @example
 * const isProjectLocked = useGetIsProjectLocked();
 * @returns boolean
 */
const useGetIsProjectLocked = () => {
  const { data: project } = useGetCurrentProject();

  return !isProjectEditable(project);
};

export default useGetIsProjectLocked;
